export const DICT_SELECT_PROPS = {
  optionValue: 'Code',
  optionLabel: 'Description',
  showLabelOnly: false,
};

export const DEFAULT_VALUES = {
  PartyType: 'Person',
  ptsPartyID: null,
  PartyRelationship: '',
  PriorityOrder: 0,
  AdvisoryText: '',
};
